import script from "./SuggestsSearchComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuggestsSearchComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SuggestsSearchComponent.vue?vue&type=style&index=0&id=5d1d31f4&lang=css"

const __exports__ = script;

export default __exports__